import useMediaQuery from '@mui/material/useMediaQuery';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { getUser } from '../../helpers/token';
import PostGrid from '../Grid/PostGrid';
import Header from '../Header/Header';
import CommunitySidebar from './CommunitySidebar';
import JoinCard from './JoinCard';

const StickyBox = dynamic(() => import('react-sticky-box'), {
  ssr: false,
});

export default function Communities() {
  const renderLeftSidebar = useMediaQuery('(min-width: 768px)');
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  return (
    <>
      <Header
        subheader="Communities"
        active="communities"
        drawerItems={<CommunitySidebar />}
      />
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-4 d-none d-xl-block d-lg-block d-md-block">
            {renderLeftSidebar ? (
              <StickyBox offsetTop={65} offsetBottom={10}>
                <div className="row">
                  <div className="col-xl-9 col-12">
                    <CommunitySidebar />
                  </div>
                </div>
              </StickyBox>
            ) : (
              <></>
            )}
          </div>
          <div className="col-xl-6 col-lg-8 col-md-8 col-sm-12 p-0">
            {user && (
              <PostGrid
                active="communities"
                query={{
                  orderby: 'createdAt',
                  limit: 10,
                  following: ['communities'],
                }}
                grid={{ lg: 12, md: 12, sm: 12, xs: 12 }}
                cardHeight={330}
                poststyle="grid"
              />
            )}
            {user === undefined && (
              <div className="mt-3">
                <JoinCard text="join your favorite travel communities" />
              </div>
            )}
          </div>
          <div className="col-xl-3 d-xl-block d-none" />
        </div>
      </div>
    </>
  );
}
